$( document ).on('turbolinks:load', function() {

	$(".rat").on("click", ".full5", function(){
		var setup_id = $(this).parent().data("id"),
		 	user3_id = $(this).parent().data("id2");

	$('div#setupvote').addClass("hidden");
	$('div#rating').toggle();
	$('div#rating').delay(4000).queue(function() { $(this).remove(); });

	$.ajax({
		url: "/setuprating/rating",
		method: "POST",
		data: { setup_id: setup_id, user3_id: user3_id, rating: "5" },
		sucess: function(){
			console.log("sucess..");
		}
	})
	});


	$(".rat").on("click", ".full4", function(){
		var setup_id = $(this).parent().data("id"),
		 	user3_id = $(this).parent().data("id2");

	$('div#setupvote').addClass("hidden");
	$('div#rating').toggle();
	$('div#rating').delay(4000).queue(function() { $(this).remove(); });

	$.ajax({
		url: "/setuprating/rating",
		method: "POST",
		data: { setup_id: setup_id, user3_id: user3_id, rating: "4" },
		sucess: function(){
			console.log("sucess..");
		}
	})
	});


	$(".rat").on("click", ".full3", function(){
		var setup_id = $(this).parent().data("id"),
		 	user3_id = $(this).parent().data("id2");

	$('div#setupvote').addClass("hidden");
	$('div#rating').toggle();
	$('div#rating').delay(4000).queue(function() { $(this).remove(); });

	$.ajax({
		url: "/setuprating/rating",
		method: "POST",
		data: { setup_id: setup_id, user3_id: user3_id, rating: "3" },
		sucess: function(){
			console.log("sucess..");
		}
	})
	});


	$(".rat").on("click", ".full2", function(){
		var setup_id = $(this).parent().data("id"),
		 	user3_id = $(this).parent().data("id2");

	$('div#setupvote').addClass("hidden");
	$('div#rating').toggle();
	$('div#rating').delay(4000).queue(function() { $(this).remove(); });

	$.ajax({
		url: "/setuprating/rating",
		method: "POST",
		data: { setup_id: setup_id, user3_id: user3_id, rating: "2" },
		sucess: function(){
			console.log("sucess..");
		}
	})
	});


	$(".rat").on("click", ".full1", function(){
		var setup_id = $(this).parent().data("id"),
		 	user3_id = $(this).parent().data("id2");

	$('div#setupvote').addClass("hidden");
	$('div#rating').toggle();
	$('div#rating').delay(4000).queue(function() { $(this).remove(); });

	$.ajax({
		url: "/setuprating/rating",
		method: "POST",
		data: { setup_id: setup_id, user3_id: user3_id, rating: "1" },
		sucess: function(){
			console.log("sucess..");
		}
	})
	});

});
